import './homepage.css';
import { Header, Footer, Services, Partners, Offers, News, Casestudies } from '../../containers';

const Homepage = () => {
  return (
    <><Header /><Services /><Offers /><Casestudies /><News /><Partners /><Footer /></>

  )
}
export default Homepage